// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2i_CB","header":"Messages_header__2f-uy"};